import React from 'react'
import PropTypes from 'prop-types'

import { withAppContext } from 'Services/Context'

import { Container, Tip } from './styles'

const Tooltip = ({ children, text, underlined }) => (
  <Container underlined={underlined ? 1 : 0}>
    <Tip>{text}</Tip>
    {children}
  </Container>
)

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.string,
  underlined: PropTypes.bool,
}

Tooltip.defaultProps = {
  text: null,
  underlined: false,
}

export default withAppContext(Tooltip)
